/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-27 16:02:16
 * @LastEditors: K
 * @LastEditTime: 2022-10-09 09:27:30
 */
import { unwrapResult } from "@reduxjs/toolkit"
import {
  Cascader,
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Menu,
  Modal,
  Popover,
  Radio,
  Row,
  Select,
  Space,
  Tag,
} from "antd"
import moment from "moment"
import React, { ReactElement, useContext, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import { ThemeContext } from "../../../theme/ThemeContext"
import { DateTimeFormatSimple } from "../../../models/datetime"
import { InfoCircleOutlined } from "@ant-design/icons"
import OrgNameIcon from "../assets/organization/orgName.jpg"
import ShtyxydmIcon from "../assets/organization/shtyxydm.jpg"
import JyxzIcon from "../assets/organization/jyxz.jpg"
import SyzxsIcon from "../assets/organization/syzxs.jpg"
import FddbrIcon from "../assets/organization/fddbr.jpg"
import ZyfzeIcon from "../assets/organization/zyfzr.jpg"
import YljgdzIcon from "../assets/organization/yljgdz.jpg"
import ZlxmmcIcon from "../assets/organization/zlxmmc.jpg"
import ZczjIcon from "../assets/organization/zczj.jpg"
import FwfsIcon from '../assets/organization/fwfs.png'
import { unitCategoryList } from "./data"
import { getAddress } from "../../treatment/editor/recipeEditorSlice"
import { selectCredentials } from "../../../app/applicationSlice"

interface ReportModalProps {
  visible: boolean
  data: any
  type: number,
  reportLoading: boolean
  onCancel: () => void
  onOk: (data: any) => void
}

export const ReportModal = ({
  visible,
  data,
  type,
  reportLoading,
  onCancel,
  onOk,
}: ReportModalProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const { CheckableTag } = Tag

  const { Option } = Select

  const { TextArea } = Input

  const theme = useContext(ThemeContext)

  const credentials = useSelector(selectCredentials)

  const [areaList, setAreaList] = useState([])

  const [idCardRules, setIdCardRules] = useState<any[]>([
    {
      pattern: /(^\d{15}$)|(^\d{16}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
      message: "身份证格式错误",
    },
    {
      max: 18,
      message: "最长18位!",
    },
    {
      required: true,
    },
  ])

  useEffect(() => {
    if (visible) {
      const cityCode: any = credentials?.tenantCityCode
        ? Number(credentials?.tenantCityCode + "000000")
        : ""
      dispatch(getAddress(cityCode))
        .then(unwrapResult)
        .then((res: any) => {
          setAreaList(
            res?.map((v: any) => {
              return { value: v.code, label: v.name }
            })?.filter((t: any) => t.label != "市辖区")
          )
        })
      if (data) {
        form.setFieldsValue({
          ...data,
          regioncode: data?.regioncode ? Number(data?.regioncode) : '',
          effectEndDate: data?.effectEndDate ? moment(data?.effectEndDate) : '',
          effectStartDate: data?.effectStartDate ? moment(data?.effectStartDate) : '',
          nextCheckTime: data?.nextCheckTime ? moment(data?.nextCheckTime) : '',
        })
      }
    } else {
      form.resetFields()
    }
  }, [visible])

  return (
    <Modal
      visible={visible}
      title={type == 1 ? "上报机构" : "机构信息调整"}
      width={1200}
      cancelText="取消"
      okText="确认提交"
      confirmLoading={reportLoading}
      onCancel={onCancel}
      onOk={form.submit}
    >
      <Form
        form={form}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
        autoComplete="off"
        onFinish={(values) => {
          const data = {
            ...values,
            effectStartDate: values.effectStartDate
              ? moment(values.effectStartDate).format(DateTimeFormatSimple)
              : null,
            effectEndDate: values.effectEndDate
              ? moment(values.effectEndDate).format(DateTimeFormatSimple)
              : null,
            nextCheckTime: values.nextCheckTime
              ? moment(values.nextCheckTime).format(DateTimeFormatSimple)
              : null,
          }
          const processedValues = Object.fromEntries(
            Object.entries(data).map(([key, value]) => [
              key,
              value === "" ? null : value, // 转换逻辑
            ])
          )
          onOk(processedValues)
        }}
      >
        <Row>
          <Col span={24}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="机构名称"
                  labelCol={{ span: 4 }}
                  wrapperCol={{ span: 20 }}
                  name="name"
                  rules={[{ required: true }]}
                >
                  <Input allowClear placeholder="请输入" />
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <div>
                      <img
                        src={OrgNameIcon}
                        alt=""
                        style={{ width: "400px" }}
                      />
                    </div>
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="机构第二名称"
                  name="secondName"
                  labelCol={{ span: 4 }}
                  wrapperCol={{ span: 20 }}
                >
                  <Input allowClear placeholder="请输入" />
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <div style={{ width: "300px" }}>
                      机构第二名称：是指经卫生行政部门核准的、在正式名称之外使用的另一个合法名称。如没有第二名称则不用填
                    </div>
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="社会统一信用代码"
                  name="uniCode"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  rules={[{ required: true }]}
                >
                  <Input allowClear placeholder="请输入" />
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <img src={ShtyxydmIcon} alt="" style={{ width: "400px" }} />
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={11}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="营业状态"
                  name="operateStatus"
                  rules={[{ required: true }]}
                >
                  <Select placeholder="请选择" allowClear>
                    <Option value={0}>正常营业</Option>
                    <Option value={1}>关闭</Option>
                    <Option value={2}>暂停营业</Option>
                    <Option value={3}>注销</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="医院级别"
                  name="institutionalLevel"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  rules={[{ required: true }]}
                >
                  <Select placeholder="请选择" allowClear>
                    <Option value={0}>一级</Option>
                    <Option value={1}>二级</Option>
                    <Option value={2}>三级</Option>
                    <Option value={3}>未定级</Option>
                    <Option value={4}>无级别</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <div style={{ width: "300px" }}>
                      <p>医院级别：</p>
                      <p>
                        一级：提供基层基本医疗、预防保健、康复和公共卫生服务，是居民健康管理的“守门人”。社区卫生服务中心（站）、乡镇卫生院、村卫生室/个体诊所、部分专科门诊部
                      </p>
                      <p>
                        二级：承担区域常见病、多发病的诊疗和急危重症抢救，向上转诊疑难病例，向下承接康复患者。县级人民医院、市级专科医院、企业职工医院
                      </p>
                      <p>
                        三级：承担疑难危重症诊疗、医学教育、科研任务，是国家级或省级医疗中心。如综合性三甲医院、省级专科医院、大学附属医院</p>
                      <p>
                        未定级：未参与等级评审，或不符合分级标准但经合法登记的医疗机构。如民营诊所、门诊部、社区卫生服务站、村卫生室
                      </p>
                      <p>
                        无级别：根据法规不适用分级管理的机构，或承担特殊职能的医疗机构。如急救中心（站）、临床检验中心、血液中心、采供血机构、护理院、养老机构内设医疗机构
                      </p>
                    </div>
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={11}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="单位类别"
                  name="unitCategory"
                  rules={[{ required: true }]}
                >
                  <Select placeholder="请选择" allowClear>
                    {unitCategoryList?.map((v) => {
                      return (
                        <Option value={v.value} key={v.value}>
                          {v.label}
                        </Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="经营性质"
                  name="operateType"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  rules={[{ required: true }]}
                >
                  <Select placeholder="请选择" allowClear>
                    <Option value={0}>营利性</Option>
                    <Option value={1}>非营利性（政府办）</Option>
                    <Option value={2}>非营利性（非政府办）</Option>
                    <Option value={3}>非营利性</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <img src={JyxzIcon} alt="" style={{ width: "400px" }} />
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={11}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="所有制形式"
                  name="ownershipType"
                  rules={[{ required: true }]}
                >
                  <Select placeholder="请选择" allowClear>
                    <Option value={0}>私有</Option>
                    <Option value={1}>集体</Option>
                    <Option value={2}>股份制</Option>
                    <Option value={3}>全民</Option>
                    <Option value={4}>合伙制</Option>
                    <Option value={5}>股份合作制</Option>
                    <Option value={6}>中外合资合作</Option>
                    <Option value={7}>国有</Option>
                    <Option value={8}>其他</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <img src={SyzxsIcon} alt="" style={{ width: "400px" }} />
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="有效开始日期"
                  name="effectStartDate"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  rules={[{ required: true }]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    format={DateTimeFormatSimple}
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <div style={{ width: "300px" }}>
                      有效开始日期：指《医疗机构执业许可证》的生效日期
                    </div>
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={11}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="有效结束日期"
                  name="effectEndDate"
                  rules={[{ required: true }]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    format={DateTimeFormatSimple}
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <div style={{ width: "300px" }}>
                      有效结束日期：指《医疗机构执业许可证》的到期日期
                    </div>
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="下一个校验日期"
                  name="nextCheckTime"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    format={DateTimeFormatSimple}
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <div style={{ width: "300px" }}>
                      下一个校验日期：是指医疗机构必须按照法定周期向卫生健康行政部门申请执业许可复核的截止日期
                    </div>
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={11}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="床位数"
                  name="bedAmount"
                >
                  <Input allowClear placeholder="请输入" />
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <div style={{ width: "300px" }}>
                      床位数：没有住院服务的机构无需填写
                    </div>
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item label="牙科诊椅数" name="dentalChairAmount" labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}>
                  <Input allowClear placeholder="请输入" />
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <div style={{ width: "300px" }}>
                      牙科诊椅数：没有口腔服务的无需填写
                    </div>
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={11}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="法定代表人"
                  name="legalRepresentative"
                  rules={[{ required: true }]}
                >
                  <Input allowClear placeholder="请输入" />
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <img src={FddbrIcon} alt="" style={{ width: "400px" }} />
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="法人证件号"
                  name="corporationNumber"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  rules={idCardRules}
                >
                  <Input allowClear placeholder="请输入" />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={11}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="邮编"
                  name="postalCode"
                >
                  <Input allowClear placeholder="请输入" />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="主要负责人"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  name="chargePerson"
                >
                  <Input allowClear placeholder="请输入" />
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <img src={ZyfzeIcon} alt="" style={{ width: "400px" }} />
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={11}>
            <Row>
              <Col span={22}>
                <Form.Item label="负责人证件号" name="chargePersonNumber">
                  <Input allowClear placeholder="请输入" />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="行政区划名称"
                  name="regioncode"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  rules={[{ required: true }]}
                >
                  <Select placeholder="请选择" allowClear>
                    {areaList?.map((v: any) => {
                      return (
                        <Option value={v.value} key={v.value}>
                          {v.label}
                        </Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="医疗机构地址"
                  name="address"
                  labelCol={{ span: 4 }}
                  wrapperCol={{ span: 20 }}
                  rules={[{ required: true }]}
                >
                  <Input allowClear placeholder="请输入" />
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <img src={YljgdzIcon} alt="" style={{ width: "400px" }} />
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="诊疗科目名称"
                  name="diagnosisSubject"
                  rules={[{ required: true }]}
                  labelCol={{ span: 4 }}
                  wrapperCol={{ span: 20 }}
                >
                  <TextArea rows={3} placeholder="请输入" allowClear />
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <img src={ZlxmmcIcon} alt="" style={{ width: "400px" }} />
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="抗菌药品静脉输注权限"
                  name="antibacterialState"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  rules={[{ required: true }]}
                >
                  <Select placeholder="请选择" allowClear>
                    <Option value={0}>无权限</Option>
                    <Option value={1}>有权限</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <div style={{ width: "300px" }}>
                      <p>
                        抗菌药品静脉输注权限：医疗机构对抗菌药物（尤其是静脉输注抗菌药物）的使用有严格的权限管理规定。
                      </p>
                      <p>
                        三级医院：可开展所有级别抗菌药物静脉输注，但特殊使用级需审批。
                      </p>
                      <p>
                        二级医院：限制级需中级职称以上医师，特殊使用级需会诊。
                      </p>
                      <p>
                        社区卫生服务中心：一般仅限非限制级，部分地区允许限制级（需备案）。
                      </p>
                      <p>
                        个体诊所/门诊部：多数禁止，少数地区允许非限制级（需备案）
                      </p>
                    </div>
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={11}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="电话"
                  name="phone"
                  rules={[{ required: true }]}
                >
                  <Input allowClear placeholder="请输入" />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="发证机关"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  name="licenceIssuingAuthority"
                >
                  <Input allowClear placeholder="请输入" />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={11}>
            <Row>
              <Col span={22}>
                <Form.Item label="批准文号" name="approvalNumber">
                  <Input allowClear placeholder="请输入" />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="注册资金"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  name="registeredCapital"
                >
                  <Input allowClear placeholder="请输入" />
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <img src={ZczjIcon} alt="" style={{ width: "400px" }} />
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={11}>
            <Row>
              <Col span={22}>
                <Form.Item label="服务方式" name="service">
                  <Select placeholder="请选择" allowClear>
                    <Option value={0}>巡诊服务</Option>
                    <Option value={1}>家庭服务</Option>
                    <Option value={2}>住院服务</Option>
                    <Option value={3}>急诊服务</Option>
                    <Option value={4}>门诊服务</Option>
                    <Option value={5}>其他服务</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <img src={FwfsIcon} alt="" style={{ width: "400px" }} />
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}
